import React from 'react';
import { Route, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSubscription } from '@apollo/react-hooks';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import UserIcon from '@material-ui/icons/PersonAdd';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { ReactComponent as ChatIcon } from 'assets/icons/chat.svg';
import { ReactComponent as AddonIcon } from 'assets/icons/addon.svg';
import { ReactComponent as ReferralIcon } from 'assets/sidebar/icon-referrral.svg';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import TimelineIcon from '@material-ui/icons/Timeline';
import EditIcon from '@material-ui/icons/Edit';
import BarChartIcon from '@material-ui/icons/BarChart';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import SendIcon from '@material-ui/icons/Send';
import FolderIcon from 'assets/sidebar/icon-folder.jsx';
import Timeline from 'assets/sidebar/icon-timeline.jsx';
import Todo from 'assets/sidebar/icon-todo';
import Team from 'assets/sidebar/icon-team.jsx';
import Stats from 'assets/sidebar/icon-stats';
import Worksheet from 'assets/sidebar/icon-worksheet.jsx';
import Essays from 'assets/sidebar/icon-essays.jsx';
import School from 'assets/sidebar/icon-school.jsx';
import PersonalStatement from 'assets/sidebar/icon-personal-statement';
import FinancialAid from 'assets/sidebar/icon-financial-aid';
import InboxIcon from '@material-ui/icons/Inbox';
import { GET_UNREAD_COUNT } from 'graphql/conversations';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChatUnreadBadge from 'components/pages/messages/chat/components/UnreadBadge';
import { ReactComponent as TeamIcon } from 'assets/icons/myteam.svg';
import { ROLES } from 'constant/userTypes';


const StudentsChildrenMenu = ({ classes, role }) => {
  return (
    <Route
      path="/students/:id"
      render={(props) => (
        <List style={{ paddingLeft: 24 }}>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/profile`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <AssignmentIndIcon fontSize="small" color="disabled" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </ListItem>
          {role !== 'student' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/team`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Team {...props} />
              </ListItemIcon>
              <ListItemText>Team</ListItemText>
            </ListItem>
          )}
          {(role === 'parent' || role === 'admin') && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/financial-aid`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FinancialAid />
              </ListItemIcon>
              <ListItemText>Financial Aid</ListItemText>
            </ListItem>
          )}
          {role === 'admin' && (
            <ListItem
              button
              exact
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Timeline />
              </ListItemIcon>
              <ListItemText>FA Scheduling</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/schedule`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <EditIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Schedule</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/exercises`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Worksheet />
              </ListItemIcon>
              <ListItemText>Exercises</ListItemText>
            </ListItem>
          )}
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/timeline`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Timeline />
            </ListItemIcon>
            <ListItemText>Timeline</ListItemText>
          </ListItem>
          {
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/common-app`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <PersonalStatement />
              </ListItemIcon>
              <ListItemText>Personal Statement</ListItemText>
            </ListItem>
          }
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/essays`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Essays />
            </ListItemIcon>
            <ListItemText>Supplemental Essays</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/schools`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <School />
            </ListItemIcon>
            <ListItemText>School List</ListItemText>
          </ListItem>
          {/* {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/snapshot`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Snapshot />
              </ListItemIcon>
              <ListItemText>360 Snapshot</ListItemText>
            </ListItem>
          )} */}
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/stats`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <BarChartIcon color="disabled" />
            </ListItemIcon>
            <ListItemText>Stats</ListItemText>
          </ListItem>
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/files`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FolderIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Files</ListItemText>
            </ListItem>
          )}

          <>
            {role === 'admin' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/credits`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AccountBalanceWalletIcon color="disabled" />
                </ListItemIcon>
                <ListItemText>Credits</ListItemText>
              </ListItem>
            )}
            {role === 'parent' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/conversations-text`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <ChatIcon color="disabled" />
                </ListItemIcon>
                <ListItemText>Text History</ListItemText>
              </ListItem>
            )}
            {role === 'admin' ||
              (role === 'parent' && (
                <ListItem
                  button
                  activeClassName="Mui-selected"
                  component={NavLink}
                  to={`/students/${props.match.params.id}/conversations`}
                  primaryTypographyProps={{
                    color: 'textPrimary',
                    classes: { root: classes.listText },
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon color="disabled" />
                  </ListItemIcon>
                  <ListItemText>Chat History</ListItemText>
                </ListItem>
              ))}
            {role === 'parent' && (
              <ListItem
                button
                onClick={() =>
                  window.analytics.track(`PageView: Add-ons page`, {
                    studentId: props.match.params.id,
                    ...props,
                  })
                }
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/upsell`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AddonIcon />
                </ListItemIcon>
                <ListItemText>Add-ons</ListItemText>
              </ListItem>
            )}
          </>
        </List>
      )}
    />
  );
};

const SoloStudentsChildrenMenu = ({ classes, role }) => {
  return (
    <Route
      path="/students/:id"
      render={(props) => (
        <List style={{ paddingLeft: 24 }}>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/profile`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <AssignmentIndIcon fontSize="small" color="disabled" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </ListItem>
          {role !== 'student' && role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/team`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Team {...props} />
              </ListItemIcon>
              <ListItemText>Team</ListItemText>
            </ListItem>
          )}
          {role === 'admin' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/financial-aid`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FinancialAid />
              </ListItemIcon>
              <ListItemText>Financial Aid</ListItemText>
            </ListItem>
          )}
          {role === 'admin' && (
            <ListItem
              button
              exact
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Timeline />
              </ListItemIcon>
              <ListItemText>FA Scheduling</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/schedule`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <EditIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Schedule</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/exercises`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Worksheet />
              </ListItemIcon>
              <ListItemText>Exercises</ListItemText>
            </ListItem>
          )}
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/timeline`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Timeline />
            </ListItemIcon>
            <ListItemText>Timeline</ListItemText>
          </ListItem>
          {
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/common-app`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <PersonalStatement />
              </ListItemIcon>
              <ListItemText>Personal Statement</ListItemText>
            </ListItem>
          }
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/essays`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Essays />
            </ListItemIcon>
            <ListItemText>Supplemental Essays</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/schools`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <School />
            </ListItemIcon>
            <ListItemText>School List</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/stats`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <BarChartIcon color="disabled" />
            </ListItemIcon>
            <ListItemText>Stats</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/files`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <FolderIcon color="disabled" />
            </ListItemIcon>
            <ListItemText>Files</ListItemText>
          </ListItem>

          <>
            {role === 'admin' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/credits`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AccountBalanceWalletIcon color="disabled" />
                </ListItemIcon>
                <ListItemText>Credits</ListItemText>
              </ListItem>
            )}
            {role === 'parent' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/upsell`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AddonIcon />
                </ListItemIcon>
                <ListItemText>Add-ons</ListItemText>
              </ListItem>
            )}
          </>
        </List>
      )}
    />
  );
};

const CohortStudentsChildrenMenu = ({ classes, role }) => {
  return (
    <Route
      path="/students/:id"
      render={(props) => (
        <List style={{ paddingLeft: 24 }}>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/profile`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <AssignmentIndIcon fontSize="small" color="disabled" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </ListItem>
          {role !== 'student' && role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/team`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Team {...props} />
              </ListItemIcon>
              <ListItemText>Team</ListItemText>
            </ListItem>
          )}
          {role === 'admin' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/financial-aid`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FinancialAid />
              </ListItemIcon>
              <ListItemText>Financial Aid</ListItemText>
            </ListItem>
          )}
          {role === 'admin' && (
            <ListItem
              button
              exact
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Timeline />
              </ListItemIcon>
              <ListItemText>FA Scheduling</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/schedule`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <EditIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Schedule</ListItemText>
            </ListItem>
          )}
          {role !== 'parent' && (
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/exercises`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Worksheet />
              </ListItemIcon>
              <ListItemText>Exercises</ListItemText>
            </ListItem>
          )}
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/timeline`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Timeline />
            </ListItemIcon>
            <ListItemText>Timeline</ListItemText>
          </ListItem>
          {
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/common-app`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <PersonalStatement />
              </ListItemIcon>
              <ListItemText>Personal Statement</ListItemText>
            </ListItem>
          }
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/essays`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <Essays />
            </ListItemIcon>
            <ListItemText>Supplemental Essays</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/schools`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <School />
            </ListItemIcon>
            <ListItemText>School List</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/stats`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <BarChartIcon color="disabled" />
            </ListItemIcon>
            <ListItemText>Stats</ListItemText>
          </ListItem>
          <ListItem
            button
            activeClassName="Mui-selected"
            component={NavLink}
            to={`/students/${props.match.params.id}/files`}
            primaryTypographyProps={{
              color: 'textPrimary',
              classes: { root: classes.listText },
            }}
          >
            <ListItemIcon>
              <FolderIcon color="disabled" />
            </ListItemIcon>
            <ListItemText>Files</ListItemText>
          </ListItem>

          <>
            {role === 'admin' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/credits`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AccountBalanceWalletIcon color="disabled" />
                </ListItemIcon>
                <ListItemText>Credits</ListItemText>
              </ListItem>
            )}
            {role === 'parent' && (
              <ListItem
                button
                activeClassName="Mui-selected"
                component={NavLink}
                to={`/students/${props.match.params.id}/upsell`}
                primaryTypographyProps={{
                  color: 'textPrimary',
                  classes: { root: classes.listText },
                }}
              >
                <ListItemIcon>
                  <AddonIcon />
                </ListItemIcon>
                <ListItemText>Add-ons</ListItemText>
              </ListItem>
            )}
          </>
        </List>
      )}
    />
  );
};

const InboxChildrenMenu = ({ classes, role }) => {
  return (
    <List className={classes.inboxChildrenMenu}>
      <ListItem
        button
        activeClassName="Mui-selected"
        component={NavLink}
        to={`/inbox/email`}
        primaryTypographyProps={{
          color: 'textPrimary',
          classes: { root: classes.listText },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          primary="Email"
        />
        <UnreadCount type="email" classes={classes} />
      </ListItem>
      {role !== ROLES.FA && (
        <ListItem
          button
          activeClassName="Mui-selected"
          component={NavLink}
          to={`/inbox/sms`}
          primaryTypographyProps={{
            color: 'textPrimary',
            classes: { root: classes.listText },
          }}
        >
          <ListItemText
            primaryTypographyProps={{ variant: 'body2' }}
            primary="Text"
          />
          <UnreadCount type="sms" classes={classes} />
        </ListItem>
      )}
      <ListItem
        button
        activeClassName="Mui-selected"
        component={NavLink}
        to={`/inbox/messages`}
        primaryTypographyProps={{
          color: 'textPrimary',
          classes: { root: classes.listText },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          primary="Chat"
        />
        <ChatUnreadBadge classes={classes} />
      </ListItem>
    </List>
  );
};

const GroupsChildrenMenu = ({ classes }) => {
  return (
    <List className={classes.inboxChildrenMenu}>
      <ListItem
        button
        activeClassName="Mui-selected"
        component={NavLink}
        to={`/groups`}
        primaryTypographyProps={{
          color: 'textPrimary',
          classes: { root: classes.listText },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          primary="Groups"
        />
      </ListItem>
      <ListItem
        button
        activeClassName="Mui-selected"
        component={NavLink}
        to={`/groups/sms`}
        primaryTypographyProps={{
          color: 'textPrimary',
          classes: { root: classes.listText },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          primary="Text"
        />
        <UnreadCount isGroup type="sms" classes={classes} />
      </ListItem>
      <ListItem
        button
        activeClassName="Mui-selected"
        component={NavLink}
        to={`/groups/messages`}
        primaryTypographyProps={{
          color: 'textPrimary',
          classes: { root: classes.listText },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          primary="Chat"
        />
        <ChatUnreadBadge isGroup classes={classes} />
      </ListItem>
    </List>
  );
};

const UnreadCount = ({ classes, type, isGroup = false }) => {
  const user = useSelector((s) => s.user.user);
  const { data } = useSubscription(GET_UNREAD_COUNT, {
    variables: { type, userId: user.id, isGroup },
    fetchPolicy: 'network-only',
  });
  if (data && data.result) {
    const count = data.result.aggregate.sum.count;
    if (count) {
      return (
        <ListItemSecondaryAction>
          <span className={classes.badge}>{count}</span>
        </ListItemSecondaryAction>
      );
    }
    return null;
  }
  return null;
};

export const StudentSidebar = [
  {
    icon: Todo,
    title: 'To Do',
    url: '/todos',
  },
  {
    icon: Timeline,
    title: 'My Timeline',
    url: '/timeline',
  },
  {
    icon: Team,
    title: 'My Team',
    url: '/team',
  },
  {
    icon: Stats,
    title: 'My Stats',
    url: '/stats',
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
  {
    icon: Worksheet,
    title: 'Exercise Library',
    url: '/exercises',
  },
  {
    icon: PersonalStatement,
    title: 'Personal Statement',
    url: '/common-app',
  },
  {
    icon: Essays,
    title: 'Supplemental Essays',
    url: '/essays',
  },
  {
    icon: School,
    title: 'School List',
    url: '/schools',
  },
  {
    icon: AddonIcon,
    title: 'Add-ons',
    url: '/addons',
  },
  // {
  //   icon: Snapshot,
  //   title: '360 Snapshot',
  //   url: '/snapshot',
  // },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const SoloStudentSidebar = [
  {
    icon: Todo,
    title: 'To Do',
    url: '/todos',
  },
  {
    icon: Timeline,
    title: 'My Timeline',
    url: '/timeline',
  },
  {
    icon: Stats,
    title: 'My Stats',
    url: '/stats',
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
  {
    icon: Worksheet,
    title: 'Exercise Library',
    url: '/exercises',
  },
  {
    icon: PersonalStatement,
    title: 'Personal Statement',
    url: '/common-app',
  },
  {
    icon: Essays,
    title: 'Supplemental Essays',
    url: '/essays',
  },
  {
    icon: School,
    title: 'School List',
    url: '/schools',
  },
  {
    icon: AddonIcon,
    title: 'Add-ons',
    url: '/addons',
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const CohortStudentSidebar = [
  {
    icon: Todo,
    title: 'To Do',
    url: '/todos',
  },
  {
    icon: Timeline,
    title: 'My Timeline',
    url: '/timeline',
  },
  {
    icon: Stats,
    title: 'My Stats',
    url: '/stats',
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
  {
    icon: Worksheet,
    title: 'Exercise Library',
    url: '/exercises',
  },
  {
    icon: PersonalStatement,
    title: 'Personal Statement',
    url: '/common-app',
  },
  {
    icon: Essays,
    title: 'Supplemental Essays',
    url: '/essays',
  },
  {
    icon: School,
    title: 'School List',
    url: '/schools',
  },
  {
    icon: AddonIcon,
    title: 'Add-ons',
    url: '/addons',
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const ParentSidebar = [
  {
    title: 'Students',
    url: '/students',
    icon: TeamIcon,
    Children: StudentsChildrenMenu,
  },
  {
    title: 'Chat',
    url: '/inbox',
    icon: ChatIcon,
    renderSecondary: (classes) => <ChatUnreadBadge classes={classes} />,
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const SoloParentSidebar = [
  {
    title: 'Students',
    url: '/students',
    icon: TeamIcon,
    Children: SoloStudentsChildrenMenu,
  },
  {
    title: 'Chat',
    url: '/inbox',
    icon: ChatIcon,
    renderSecondary: (classes) => <ChatUnreadBadge classes={classes} />,
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const CohortParentSidebar = [
  {
    title: 'Students',
    url: '/students',
    icon: TeamIcon,
    Children: CohortStudentsChildrenMenu,
  },
  {
    title: 'Chat',
    url: '/inbox',
    icon: ChatIcon,
    renderSecondary: (classes) => <ChatUnreadBadge classes={classes} />,
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const LcSidebar = [
  {
    title: 'To-Do List',
    url: '/todos',
    icon: Todo,
  },
  {
    title: 'Essay Review',
    url: '/essays',
    icon: Todo,
  },
  {
    title: 'Sessions',
    url: '/sessions',
    icon: Todo,
  },
  {
    title: 'Inbox',
    url: '/inbox/email',
    icon: InboxIcon,
    Children: InboxChildrenMenu,
  },
  {
    title: 'Engagement',
    url: '/engagement',
    icon: BarChartIcon,
  },
  {
    title: 'Students',
    url: '/students',
    icon: Team,
    Children: StudentsChildrenMenu,
  },
  {
    title: 'Calendar',
    url: '/calendar',
    icon: CalendarTodayIcon,
  },
  {
    title: 'Curriculum',
    url: '/curriculum',
    icon: Worksheet,
  },
  {
    title: 'Timeline Templates',
    url: '/timeline-templates',
    icon: Timeline,
  },
  {
    title: 'Groups',
    url: '/groups',
    icon: GroupWorkIcon,
    Children: GroupsChildrenMenu,
  },
  {
    title: 'Time Tracker',
    url: '/time-tracker',
    icon: AccessTimeIcon,
  },
  {
    title: 'Campaigns',
    url: '/campaigns',
    icon: SendIcon,
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const HcSidebar = [
  {
    title: 'To-Do List',
    url: '/todos',
    icon: Todo,
  },
  {
    title: 'Essay Review',
    url: '/essays',
    icon: Todo,
  },
  {
    title: 'Sessions',
    url: '/sessions',
    icon: Todo,
  },
  {
    title: 'Inbox',
    url: '/inbox/email',
    icon: InboxIcon,
    Children: InboxChildrenMenu,
  },
  {
    title: 'Engagement',
    url: '/engagement',
    icon: BarChartIcon,
  },
  {
    title: 'Students',
    url: '/students',
    icon: Team,
    Children: StudentsChildrenMenu,
  },
  {
    title: 'Calendar',
    url: '/calendar',
    icon: CalendarTodayIcon,
  },
  {
    title: 'Curriculum',
    url: '/curriculum',
    icon: Worksheet,
  },
  {
    title: 'Timeline Templates',
    url: '/timeline-templates',
    icon: Timeline,
  },
  {
    title: 'Groups',
    url: '/groups',
    icon: GroupWorkIcon,
    Children: GroupsChildrenMenu,
  },
  {
    title: 'Time Tracker',
    url: '/time-tracker',
    icon: AccessTimeIcon,
  },
  {
    title: 'Campaigns',
    url: '/campaigns',
    icon: SendIcon,
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
  {
    icon: ReferralIcon,
    title: 'Refer a Friend',
    subtitle: (
      <div>
        For each valid invitation, you will receive <b>$5</b>
      </div>
    ),
    url: '/referral',
  },
];

export const FASidebar = [
  {
    title: 'To-Do List',
    url: '/todos',
    icon: Todo,
  },
  {
    title: 'Inbox',
    url: '/inbox/email',
    icon: InboxIcon,
    Children: InboxChildrenMenu,
  },
  {
    title: 'Students',
    url: '/students',
    icon: Team,
    Children: ({ classes }) => (
      <Route
        path="/students/:id"
        render={(props) => (
          <List style={{ paddingLeft: 24 }}>
            <ListItem
              button
              exact
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Timeline />
              </ListItemIcon>
              <ListItemText>Scheduling</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/profile`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <AssignmentIndIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Profile</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/team`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Team />
              </ListItemIcon>
              <ListItemText>Team</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/timeline`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <TimelineIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Timeline</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/exercises`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <Worksheet />
              </ListItemIcon>
              <ListItemText>Exercise Library</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/schools`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <School />
              </ListItemIcon>
              <ListItemText>School List</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/financial-aid`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FinancialAid />
              </ListItemIcon>
              <ListItemText>Financial Aid</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/stats`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <BarChartIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Stats</ListItemText>
            </ListItem>
            <ListItem
              button
              activeClassName="Mui-selected"
              component={NavLink}
              to={`/students/${props.match.params.id}/files`}
              primaryTypographyProps={{
                color: 'textPrimary',
                classes: { root: classes.listText },
              }}
            >
              <ListItemIcon>
                <FolderIcon color="disabled" />
              </ListItemIcon>
              <ListItemText>Files</ListItemText>
            </ListItem>
          </List>
        )}
      />
    ),
  },
  {
    title: 'Calendar',
    url: '/calendar',
    icon: CalendarTodayIcon,
  },
  {
    title: 'Groups',
    url: '/groups',
    icon: GroupWorkIcon,
  },
  {
    title: 'Time Tracker',
    url: '/time-tracker',
    icon: AccessTimeIcon,
  },
  {
    title: 'Campaigns',
    url: '/campaigns',
    icon: SendIcon,
  },
  {
    icon: FolderIcon,
    title: 'My Files',
    url: '/files',
  },
];

export const AdminSidebar = [
  {
    title: 'Inbox',
    url: '/inbox/email',
    icon: InboxIcon,
    Children: InboxChildrenMenu,
  },
  {
    title: 'Engagement',
    url: '/engagement',
    icon: BarChartIcon,
  },
  {
    title: 'Students',
    url: '/students',
    icon: Team,
    Children: StudentsChildrenMenu,
  },
  {
    title: 'Guardians',
    url: '/guardians',
    icon: Team,
  },
  {
    title: 'College Coaches',
    url: '/lcs',
    icon: SupervisorAccountIcon,
  },
  {
    title: 'Head Counselors',
    url: '/hcs',
    icon: SupervisorAccountIcon,
  },
  {
    title: 'Financial Counselors',
    url: '/fas',
    icon: SupervisorAccountIcon,
  },
  {
    title: 'Create User',
    url: '/create-user',
    icon: UserIcon,
  },
  {
    title: 'Curriculum Builder',
    url: '/curriculum',
    icon: Worksheet,
  },
  {
    title: 'Timeline Templates',
    url: '/timeline-templates',
    icon: Timeline,
  },
  {
    title: 'Groups',
    url: '/groups',
    icon: GroupWorkIcon,
    Children: GroupsChildrenMenu,
  },
  {
    title: 'Products',
    url: '/products',
    icon: Todo,
  },
  {
    title: 'Payments',
    url: '/payments',
    icon: ReceiptIcon,
  },
  {
    title: 'Colleges',
    url: '/colleges',
    icon: Todo,
  },
  {
    title: 'Notification Templates',
    url: '/notification-templates',
    icon: TextFieldsIcon,
  },
  {
    title: 'Subscriptions',
    url: '/subscriptions',
    icon: Todo,
  },
  {
    title: 'To-Do List',
    url: '/todos',
    icon: Todo,
  },
  {
    title: 'Campaigns',
    url: '/campaigns',
    icon: SendIcon,
  },
  {
    title: 'Essays',
    url: '/essays',
    icon: Todo,
  }
];
